export const styles = {
  tableWrapper: {
    width: '100%',
    overflowY: 'auto',
  },
}



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Locations/Container/styles.js